jQuery(document).ready(function ($) {
	"use strict";

    function validateVAT() {
        var role = $('#afreg_select_user_role').val();
        var vatInput = $('.validate-as-vat');
        var vatValue = vatInput.val();
        var vatPattern = /^[A-Za-z]{2}\d{9}$/;

        if (role === 'b2b_customer') {
            if (!vatPattern.test(vatValue)) {
                vatInput.addClass('invalid');
            } else {
                vatInput.removeClass('invalid');
            }
			$('.af-dependable-field').removeClass('hidden');
		} else {
            vatInput.removeClass('invalid');
			$('.af-dependable-field').addClass('hidden');
			alert('b');
        }
    }

    // Trigger validation on input or blur
    $('.validate-as-vat').on('input blur', function() {
        validateVAT();
    });

    // Also trigger validation when user role changes
    $('#afreg_select_user_role').on('change', function() {
        validateVAT();
    });
});
